import axios from 'axios';

export default axios.create({
  baseURL: 'https://api2.gooroo.com',
  headers: {
    'X-API-Key': 'SG33EF4xKTcY86r90syZ1XJ5G1YTBybM'
  }
});
